module.exports = __webpack_public_path__ + "media/images/spreadsheet-828e3439.jpg";